import type { ViewspecState } from "./types.ts";
import { DEFAULT_VIEWSPECS } from "./types.ts";

export interface ViewspecPreset {
  name: string;
  label: string;
  description: string;
  viewspecs: Partial<ViewspecState>;
}

export const VIEWSPEC_PRESETS: ViewspecPreset[] = [
  {
    name: "outline",
    label: "Outline",
    description: "Top-level statements only, with SIDs",
    viewspecs: {
      depthLimit: 1,
      showContent: "first-line",
      showSIDs: true,
      indentation: true,
      numbering: "sid",
    },
  },
  {
    name: "full",
    label: "Full",
    description: "All levels, all content",
    viewspecs: {
      depthLimit: null,
      showContent: "all",
      showSIDs: true,
      indentation: true,
      numbering: "sid",
    },
  },
  {
    name: "compact",
    label: "Compact",
    description: "All levels, first line only, no SIDs",
    viewspecs: {
      depthLimit: null,
      showContent: "first-line",
      showSIDs: false,
      indentation: true,
      numbering: "none",
      showBlankLines: false,
    },
  },
  {
    name: "detail",
    label: "Detail",
    description: "Two levels deep, full content, spaced",
    viewspecs: {
      depthLimit: 2,
      showContent: "all",
      showSIDs: true,
      indentation: true,
      numbering: "sid",
      showBlankLines: true,
    },
  },
  {
    name: "flat",
    label: "Flat",
    description: "All levels, no indentation, sequential numbering",
    viewspecs: {
      depthLimit: null,
      showContent: "all",
      showSIDs: false,
      indentation: false,
      numbering: "sequential",
    },
  },
];

export function getPreset(name: string): ViewspecPreset | undefined {
  return VIEWSPEC_PRESETS.find((p) => p.name === name);
}

export function applyPreset(
  current: ViewspecState,
  presetName: string
): ViewspecState {
  const preset = getPreset(presetName);
  if (!preset) return current;
  return { ...current, ...preset.viewspecs };
}
